import {
    ServiceGroupServiceData,
    ServiceGroupServicesQuery,
    ServiceGroupServiceUpdateForm,
} from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export interface ServiceGroupServiceFilterParams extends ServiceGroupServicesQuery {}

export class ServiceGroupServiceList extends LongList<
    ServiceGroupServiceData,
    ServiceGroupServiceData,
    ServiceGroupServiceFilterParams
> {
    protected identifiableFieldName = 'serviceId';

    public update(id: string, value: ServiceGroupServiceUpdateForm): void {
        const current = this.getExisting(id);

        super.update(id, { ...current, ...value });
    }

    protected create(params: ServiceGroupServiceData): ServiceGroupServiceData {
        return params;
    }
}
